export default "__VITE_ASSET__BfmNNhxJ__"